import Component from './Component'

export default class Switch extends Component {

	static _type = 'Switch'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector('input')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Value set override
		this.values = ('values' in this.params) ? this.params.values : [ 0, 1 ]

		// Create bound event handlers and register them
		this.inputListener = Switch._inputListener.bind(this)
		this.updateListener = Switch._updateListener.bind(this)
		$(this.input_el).on('input', this.inputListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event
	}

	static _inputListener () {
		// Send data to the record
		this.form.data[this.params.name] = $(this.input_el).get(0).checked ? this.values[1] : this.values[0]
	}

	static _updateListener (value, errors) {

		// If the value changed, update it on the input as well
		if ($(this.input_el).get(0).checked != (value == this.values[1])) {
			$(this.input_el).get(0).checked = (value == this.values[1])
		}

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			$(this.input_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.input_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.input_el).off('input', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.input_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
